// Axios
import Axios from "./axios"

export const addTag = (value) => {
    return new Promise((resolve, reject) => {
        const data = Axios.post(`/tag/create`, value, {
            headers: {
                'access-token': localStorage.getItem("access_token")
            }
        })
        resolve(data)
    })

}